import classNames from 'classnames';
import React from 'react';
import PropTypes from 'prop-types';
import styles from './css/TableCell.scss';

export default function TableCell({
    children,
    className,
    ...props
}) {
    const classes = classNames(styles.cell, className);
    return (
        <div {...props} className={classes}>
            {children}
        </div>
    );
}

TableCell.propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
};
